// extracted by mini-css-extract-plugin
module.exports = {"container":"user-management_container_99IgB","cards":"user-management_cards_5UbX7"};